import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FxFlexDirective, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective, ResponsiveService } from '@rspl-ui';

import { BaseSectionComponent } from '../base-section/base.component';

@Component({
  selector: 'rspl-courier-section-split-landing',
  templateUrl: './courier.component.html',
  styleUrl: './courier.component.scss',
  imports: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, FxFlexDirective, MatIcon],
})
export class CourierSectionComponent extends BaseSectionComponent {
  constructor(public override responsiveService: ResponsiveService) {
    super(responsiveService);
  }
}
